import React, { useEffect, useMemo, useState } from 'react';
import TableComponent from 'app/components/TableComponent';
import { Modal } from 'react-bootstrap-v5';
import './styles/departamentos.css';
import { KTSVG } from '_metronic/helpers/components/KTSVG';
import { FilterView } from 'app/components/FilterView';
import { InputModalSelect } from 'app/components/InputsComponents/InputModalSelect';
import { InputModalText } from 'app/components/InputsComponents/InputModalText';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { OBLIGATORY } from 'app/utilities/constants';
import { departmentCreateAndUpdate, getAllDepartments, getAllDepartmentsFilter, getAllDepartmentsFilterDesc } from 'app/service/configuration/Departamentos';
import { DepartamentoType } from 'app/types/configuracion/departamentos';
import { CheckboxComponent } from 'app/components/CheckboxComponent';
import { getCompany, getUsersRC } from 'app/service/catalog/Catalogs';
import { AlertInfoComponent } from 'app/components/AlertComponent/AlertInfoComponent';

const heads = [
    { code: 'name', label: 'Código' },
    { code: 'descripcion', label: 'Descripción' },
    { code: 'bonusCalculation', label: 'Calcula Bono' },
    { code: 'commissionCalculation', label: 'Calcula Comisiones' },
    { code: 'solicita', label: 'Solicita' },
    { code: 'autoriza', label: 'Autoriza' },
];

const DepartamentosSchema = Yup.object().shape({
    name: Yup.string()
        .required('Este campo es requerido')
        .min(1, "Mínimo 1 caracter")
        .max(5, "Máximo 5 caracteres"),
    description: Yup.string()
        .required('Este campo es requerido')
        .min(3, "Mínimo 3 caracteres")
        .max(101, "Máximo 100 caracteres"),
    company: Yup.number()
        .required('Este campo es requerido')
        .notOneOf([0], "Seleccione una opción"),
    bonusCalculation: Yup.number()
        .required('Este campo es requerido')
        .notOneOf([0], "Seleccione una opción"),
    commissionCalculation: Yup.number()
        .required('Este campo es requerido')
        .notOneOf([0], "Seleccione una opción"),
    solicita: Yup.number()
        .required('Este campo es requerido')
        .notOneOf([0], "Seleccione una opción"),
    autoriza: Yup.number()
        .required('Este campo es requerido')
        .notOneOf([0], "Seleccione una opción"),
});

const DepartamentosView: React.FC = () => {
    const [show, setShow] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState<boolean>(false);
    const [loadingGrid, setLoadingGrid] = useState<boolean>(true);

    const [isFiltered, setIsFiltered] = useState<boolean>(false);
    const [employeeName, setEmployeeName] = useState<string>('');
    const [employeeNumber, setEmployeeNumber] = useState<string>('');
    const [selectedOption, setSelectedOption] = useState<string>('');

    const [departments, setDepartments] = useState<DepartamentoType[]>([]);
    const [selectOptionsCompanies, setSelectOptionsCompanies] = useState<any[]>([]);
    const [users, setUsers] = useState<any[]>([]);

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(5);
    const [totalRecords, setTotalRecords] = useState<number>(0);

    const [id, setId] = useState<number | undefined | null>(null);
    const [companyId, setCompanyId] = useState<number | undefined | null>(null);
    const fetchCompanies = async (): Promise<void> => {
        try {
            const res = await getCompany();
            setSelectOptionsCompanies(res.records.map((record: any) => ({
                id: record.id, description: record.description
            })));

        } catch (err) {
            console.error("Error fetching companies", err);
        }
    }

    const fetchUsers = async (): Promise<void> => {
        try {
            const res = await getUsersRC();
            setUsers(res.records.map((record) => ({
                id: record.id,
                description: record.completeName,
            })));
            
        } catch (err) {
            console.error("Error fetching USERS", err);
        }
    }

    const fetchDepartaments = async (): Promise<void> => {
        try {
            setLoadingGrid(true);
            const res = await getAllDepartments(currentPage, pageSize);

            setDepartments((res!.records ?? []).map((record) => ({
                ...record,
                status: record?.statusId === 1 ? 'Activo' : 'Inactivo',
            })));

            setTotalRecords(res!.totalRecords); //Aqui le pongo 0 xd
        } catch (err) {
            console.error("Error: ", err)
        } finally {
            setLoadingGrid(false);
        }
    }

    const formDepartamento = useFormik<any>({
        validationSchema: DepartamentosSchema,
        initialValues: {
            name: '',
            description: '',
            company: 0, //select
            bonusCalculation: 0, //select
            commissionCalculation: 0, //select
            solicita: 0, //select
            autoriza: 0, //select
        },
        onSubmit: async (values, { setSubmitting }) => {
            const { name, company, description, bonusCalculation, commissionCalculation, solicita, autoriza } = values;
            try {
                await departmentCreateAndUpdate(
                    {
                        ...values,
                        idCompany: Number(company),
                        name: name.toUpperCase(),
                        description: description,
                        bonusCalculation: Number(bonusCalculation) === 1,
                        commissionCalculation: Number(commissionCalculation) === 1,
                        idUserSolicitor: Number(solicita),
                        idUserAuthorization: Number(autoriza),
                        id: id
                    }
                );
                setEmployeeName('');
                setEmployeeNumber('');
                setSelectedOption('');
                setIsFiltered(false);

                handleClose();
                fetchDepartaments();

                formDepartamento.resetForm();
            } catch (err) {
                console.error('Error', err);
            } finally {
                setSubmitting(false);
            }
        },
    });

    useEffect(() => {
        if (isFiltered) {
            if (selectedOption === '1' && employeeName) {
                getAllDepartmentsFilter(currentPage, pageSize, employeeName).then(res => {
                    if (res === null) {
                        setTotalRecords(0);
                        return setDepartments([]);
                    }
                    setDepartments((res!.records ?? []).map((record) => ({
                        ...record,
                    })));
                    setTotalRecords(res!.totalRecords ?? 0);
                });
            }

            if (selectedOption === '2' && employeeNumber) {
                getAllDepartmentsFilterDesc(currentPage, pageSize, employeeNumber).then(res => {
                    if (res === null) {
                        setTotalRecords(0);
                        return setDepartments([]);
                    }
                    setDepartments((res!.records ?? []).map((record) => ({
                        ...record,
                    })));
                    setTotalRecords(res!.totalRecords ?? 0);
                });
            }
        } else {
            fetchDepartaments();
            fetchCompanies();
            fetchUsers();
        }
    }, [currentPage, pageSize, isFiltered, employeeName, employeeNumber]);

    const rows = useMemo(() => {
        if (!loadingGrid && departments.length) {
            return departments.map((row) => ({
                name: (
                    <div
                        style={{ textAlign: 'center' }}
                    >
                        {row.name}
                    </div>
                ),
                descripcion: (
                    <div
                        onClick={() => {
                            handleShow();
                            formDepartamento.setValues({
                                name: row.name,
                                description: row.description,
                                company: row.companyId,
                                bonusCalculation: row.bonusCalculation ? 1 : 2,
                                commissionCalculation: row.commissionCalculation ? 1 : 2,
                                solicita: row.idUserSolicitor,
                                autoriza: row.idUserAuthorization,
                            });
                            setId(row.id);
                            setCompanyId(row.companyId);
                        }}
                        style={{ cursor: 'pointer', color: 'blue' }}
                    >
                        {row.description}
                    </div>
                ),
                bonusCalculation: (
                    <div style={{ textAlign: 'center' }}>
                        <CheckboxComponent isChecked={row.bonusCalculation} />
                    </div>
                ),
                commissionCalculation: (
                    <div style={{ textAlign: 'center' }}>
                        <CheckboxComponent isChecked={row.commissionCalculation} />
                    </div>
                ),
                solicita: (
                    <div style={{ textAlign: 'center' }}>{
                        `${row.userSolicitor.name} ${row.userSolicitor.fatherLastName} ${row.userSolicitor.motherLastName}`
                    }
                    </div>
                ),
                autoriza: (
                    <div style={{ textAlign: 'center' }}>{
                        `${row.userAuthorizer.name} ${row.userAuthorizer.fatherLastName} ${row.userAuthorizer.motherLastName}`
                    }
                    </div>
                ),
            }));
        }
        return [];
    }, [loadingGrid, departments]);

    const handleShow = () => {
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
        setId(null);
        setCompanyId(null);
        formDepartamento.resetForm();
    };

    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedOption(e.target.value);
    };

    const toggleFilterModal = () => {
        setId(null);
        setCompanyId(null);
        setShowFilterModal((prev) => !prev);
    };

    return (
        <div className="row gy-5 g-xl-8">
            <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12">
                <div className="card card-flush p-5">
                    <div className="d-flex justify-content-between align-items-center mb-5">
                        <h3 className="fw-bold fs-4">Departamentos</h3>
                        <div className="d-flex justify-content-end gap-2">
                            <AlertInfoComponent
                                message='Si asignas un usuario como  solicitador no puedes asignarlo como  autorizador'
                                bgColor='white'
                                textColor='info'
                                textSize="7"
                                svgColor='info'
                                svgSize='3'
                                maxWidth='50%'
                                maxHeight='4.2rem'
                            />
                            <button
                                className="btn btn-light-primary border-btn"
                                onClick={() => handleShow()}
                            >
                                <KTSVG
                                    path="/media/icons/duotune/abstract/abs011.svg"
                                    className="svg-icon-2 svg-icon-gray-500 "
                                />
                            </button>
                            <button className="btn btn-light-primary border-btn w-10" onClick={toggleFilterModal}>
                                <KTSVG
                                    path="/media/icons/duotune/general/gen021.svg"
                                    className="svg-icon-5 svg-icon-gray-500"
                                />
                                <span className="ms-2">Filtrar</span>
                            </button>
                        </div>
                    </div>
                    <TableComponent
                        heads={heads}
                        rows={rows}
                        rowsPerPage={pageSize}
                        page={currentPage}
                        totalRows={totalRecords}
                        setPage={setCurrentPage}
                    />
                </div>
            </div>

            {/* Modal para departamentos */}
            <Modal
                id="kt_modal_roles"
                tabIndex={-1}
                dialogClassName="modal-dialog"
                show={show}
                onHide={handleClose}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="text-muted">Departamentos</h1>
                        <div
                            className="btn btn-sm btn-icon btn-active-color-primary"
                            onClick={handleClose}
                        >
                            <KTSVG
                                className="svg-icon-2"
                                path="/media/icons/duotune/arrows/arr061.svg"
                            />
                        </div>
                    </div>
                    <div className="modal-body mx-5">
                        <form className="form needs-validation" noValidate onSubmit={(e) => {
                            e.preventDefault(); formDepartamento.handleSubmit();
                        }}>
                            <div className='d-flex'>
                                {/* Nombre */}
                                <InputModalText
                                    formFormik={formDepartamento}
                                    label={'Código'}
                                    htmlFor={'name'}
                                    name={'name'}
                                    placeholder={'Ingrese un código'}
                                    width='50'
                                    styleBootstrapClasses='mb-5'
                                />

                                {/* Descripción */}
                                <InputModalText
                                    formFormik={formDepartamento}
                                    label={'Descripción'}
                                    htmlFor={'description'}
                                    name={'description'}
                                    placeholder={'Ingrese la descripción'}
                                    width='50'
                                    styleBootstrapClasses='mb-5'
                                />
                            </div>
                            <div>
                                {/* Compañia */}
                                <InputModalSelect
                                    selectOptions={selectOptionsCompanies}
                                    formFormik={formDepartamento}
                                    label={'Compañia'}
                                    htmlFor={'company'}
                                    name={'company'}
                                    width='100'
                                    styleBootstrapClasses='mb-5'
                                />
                            </div>
                            <div className="d-flex">
                                {/* Calcula Bono */}
                                <InputModalSelect
                                    selectOptions={OBLIGATORY}
                                    formFormik={formDepartamento}
                                    label={'Calcula Bono'}
                                    htmlFor={'bonusCalculation'}
                                    name={'bonusCalculation'}
                                    width='50'
                                    styleBootstrapClasses='mb-5'
                                />
                                {/* Calcula Comisiones */}
                                <InputModalSelect
                                    selectOptions={OBLIGATORY}
                                    formFormik={formDepartamento}
                                    label={'Calcula Comisiones'}
                                    htmlFor={'commissionCalculation'}
                                    name={'commissionCalculation'}
                                    width='50'
                                    styleBootstrapClasses='mb-5'
                                />
                            </div>
                            <div className="d-flex">
                                {/* Solicita */}
                                <InputModalSelect
                                    selectOptions={users}
                                    formFormik={formDepartamento}
                                    label={'Solicita'}
                                    htmlFor={'solicita'}
                                    name={'solicita'}
                                    width={'50'}
                                />
                                {/* Autoriza */}
                                <InputModalSelect
                                    selectOptions={users}
                                    formFormik={formDepartamento}
                                    label={'Autoriza'}
                                    htmlFor={'autoriza'}
                                    name={'autoriza'}
                                    width={'50'}
                                />
                            </div>
                            {/* Botones */}
                            <div className="d-flex justify-content-between mt-4">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleClose}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-danger"
                                    style={{ backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' }}
                                >
                                    Guardar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>

            {/* Modal para el Filtro */}
            <Modal
                id="kt_modal_filter"
                tabIndex={-1}
                dialogClassName="modal-dialog"
                show={showFilterModal}
                onHide={toggleFilterModal}
            >
                {showFilterModal && (
                    <FilterView
                        handleFilterClose={toggleFilterModal}
                        handleSelectChange={handleSelectChange}
                        selectedOption={selectedOption}
                        employeeName={employeeName}
                        employeeNumber={employeeNumber}
                        setEmployeeName={setEmployeeName}
                        setEmployeeNumber={setEmployeeNumber}
                        setSelectedOption={setSelectedOption}
                        setCurrentPage={setCurrentPage}
                        setIsFiltered={setIsFiltered}
                        fetchData={() => fetchDepartaments()}
                        fetchFilterData={() => getAllDepartmentsFilter(currentPage, pageSize, employeeName)}
                        fetchFilterData2={() => getAllDepartmentsFilterDesc(currentPage, pageSize, employeeNumber)}
                        nameOptions={["Código", "Descripción"]}
                    />
                )}
            </Modal>

        </div>
    );
};

export { DepartamentosView };
